module.exports = __webpack_public_path__ + "static/media/logo05.7b7c16ac.svg";